// Configuration for brand logos and styling in PDF exports
export interface BrandConfig {
  name: string;
  displayName: string;
  primaryColor: string;
  logo?: {
    url?: string;
    base64?: string;
    width: number;
    height: number;
    aspectRatio?: number;
  };
}

// Current brand configuration
export const currentBrand: BrandConfig = {
  name: 'adidas',
  displayName: 'adidas',
  primaryColor: '#000000',
  logo: {
    url: '/brand.svg',
    // Adidas logo proportions
    width: 60,
    height: 30,
    aspectRatio: 2 // width/height
  }
};

// Pulpou brand configuration
export const pulpouBrand = {
  name: 'pulpou',
  displayName: 'PULPOU',
  primaryColor: '#3B82F6',
  logoVertical: {
    url: '/Logo_pulpou_vertical.svg',
    width: 30,
    height: 30,
    aspectRatio: 1 // Square logo
  },
  logoHorizontal: {
    url: '/logo_pulpou.svg',
    width: 30,
    height: 7,
    aspectRatio: 4.28 // Very horizontal
  }
};